import {
  ScrollTrigger
} from "./chunk.RYXMHMS2.js";
import {
  gsapWithCSS
} from "./chunk.LXB4MYP4.js";
import {
  isSizeMdDown
} from "./chunk.YDQDJZUC.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  debounce,
  smoothScroll
} from "./chunk.WXNWU2SV.js";
import {
  D,
  Oe,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-moment-page-hero/jb-moment-page-hero.scss?inline
var jb_moment_page_hero_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
header .content p {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h1 {
  font-family: var(--theme-font-xlight-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-xlight-weight, 200);
}

h1 {
  font-size: var(--theme-typo-h2-mobile-fontsize, 1.938rem);
  line-height: var(--theme-typo-h2-mobile-lineheight, 2.625rem);
}
@media (min-width: 1281px) {
  h1 {
    font-size: var(--theme-typo-h2-desktop-fontsize, 2.813rem);
    line-height: var(--theme-typo-h2-desktop-lineheight, 3.813rem);
  }
}

header .content p {
  font-size: var(--theme-typo-p-big-mobile-fontsize, 1.188rem);
  line-height: var(--theme-typo-p-big-mobile-lineheight, 1.75rem);
}
@media (min-width: 1281px) {
  header .content p {
    font-size: var(--theme-typo-p-big-desktop-fontsize, 1.375rem);
    line-height: var(--theme-typo-p-big-desktop-lineheight, 2.125rem);
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
main .content, header .content {
  --_grid-gap: 16px;
  --_grid-template-columns: repeat(12, 1fr);
  display: grid;
  gap: var(--grid-row-gap, 0) var(--grid-column-gap, var(--_grid-gap));
  grid-template-columns: var(--theme-grid-template-columns, var(--_grid-template-columns));
  width: 100%;
}
@media (min-width: 960px) {
  main .content, header .content {
    --_grid-gap: 40px;
  }
}

main .content, header .content {
  padding-inline: 20px;
}

main, header {
  --_max-width: calc(100% - (2 * 6.68%));
  display: grid;
  grid-template-columns: [full-start] minmax(0, 1fr) [main-start] minmax(0, var(--theme-grid-max-width, var(--_max-width))) [main-end] minmax(0, 1fr) [full-end];
  margin-inline: auto;
}
@media (min-width: 600px) {
  main, header {
    --_max-width: calc(100% - (2 * 8.35%));
  }
}
@media (min-width: 960px) {
  main, header {
    --_max-width: calc(100% - (2 * 6.955%));
  }
}
@media (min-width: 1437px) {
  main, header {
    --_max-width: 1437px;
  }
}

:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
  padding-inline-end: var(--compensate-scrollbar);
  --rgb-primary: 255, 255, 255;
  --host-color: #fff;
  --_background-opacity: 0.3;
}

section {
  position: relative;
}
section button {
  background: transparent;
  border: 0;
  left: 50%;
  position: absolute;
  rotate: 90deg;
  top: calc(100svh - 40px);
  translate: -50% 0;
}

header {
  inline-size: 100%;
  min-block-size: 100vh;
  overflow: hidden;
  place-content: center;
  position: sticky;
  top: 0;
}
header::after {
  background-color: rgb(0, 0, 0, var(--_background-opacity));
  content: "";
  inset: 0;
  position: absolute;
  z-index: -1;
}
header .content {
  block-size: min-content;
  grid-column: main;
  position: relative;
  z-index: 2;
}
header .content > * {
  grid-column: 1/13;
}
@media (min-width: 1281px) {
  header .content > * {
    grid-column: 3/11;
  }
}
header .content > *:last-child {
  margin-block-end: 0;
}
jb-breadcrumbs {
  margin-block-end: var(--spacing-lm);
}

h1 {
  margin-block-end: var(--spacing-m);
}

.background {
  block-size: 100%;
  inline-size: 100%;
  inset: 0;
  object-fit: cover;
  object-position: center;
  position: absolute;
  z-index: -1;
}

main {
  padding-block-start: 50px;
  position: relative;
  z-index: 2;
}
main .content {
  grid-column: main;
  -webkit-transform: translate3d(0, 0, 0);
}
main .content > * {
  grid-column: 1/13;
}
@media (min-width: 1281px) {
  main .content > * {
    grid-column: 3/11;
  }
}
main .content slot {
  display: grid;
  margin-block: var(--spacing-3xl) 0;
}
@media (min-width: 1281px) {
  main .content slot {
    margin-block-end: var(--spacing-4xl);
  }
}

.line {
  display: none;
}
@media (min-width: 1281px) {
  .line {
    block-size: 100%;
    display: block;
    inline-size: 100%;
    inset: 0;
    pointer-events: none;
    position: absolute;
  }
  .line path {
    fill: none;
    stroke: white;
    stroke-width: 1;
  }
}

jb-contact-teaser-legacy {
  margin-block: var(--spacing-4xl);
}`;

// src/components/jb-moment-page-hero/jb-moment-page-hero.ts
var JBMomentPageHero = class extends h {
  constructor() {
    super(...arguments);
    this._animationPlayed = false;
  }
  async firstUpdated() {
    await this.updateComplete;
    gsapWithCSS.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({ ignoreMobileResize: false });
    this._drawLine();
    window.addEventListener(
      "resize",
      debounce(() => {
        this._drawLine();
      }, 50)
    );
    gsapWithCSS.to(this._headerContent, {
      scrollTrigger: {
        trigger: this._main,
        start: "top bottom",
        end: "+=50%",
        scrub: 0
      },
      yoyo: true,
      opacity: 0,
      scale: 0.8
    });
    gsapWithCSS.to(this, {
      scrollTrigger: {
        trigger: this._main,
        start: "top bottom",
        end: "+=50%",
        scrub: 0
      },
      yoyo: true,
      "--_background-opacity": 0.6
    });
    gsapWithCSS.to(this._headerElement.querySelector("img, jb-video"), {
      scrollTrigger: {
        trigger: this,
        start: "bottom+=100px bottom",
        end: "bottom+=100px top",
        scrub: 0
      },
      translateY: "288px"
    });
    const scrollbutton = this.shadowRoot.querySelector("button");
    gsapWithCSS.fromTo(
      scrollbutton,
      {
        opacity: 0,
        translateY: "-40px"
      },
      {
        opacity: 1,
        translateY: "0",
        duration: 1
      }
    );
    gsapWithCSS.fromTo(
      scrollbutton,
      { opacity: 1 },
      {
        scrollTrigger: {
          trigger: this._main,
          start: "top bottom",
          end: "+=50",
          scrub: 0
        },
        yoyo: true,
        opacity: 0
      }
    );
  }
  _drawLine() {
    if (isSizeMdDown()) return;
    const slotElement = this.shadowRoot.querySelector("slot");
    const slotRect = slotElement.getBoundingClientRect();
    const slotPaddingBottom = parseInt(getComputedStyle(slotElement).marginBlockEnd, 10);
    this._pathString = `M ${slotRect.left - slotRect.width / 8} ${this._headerContent.offsetTop} V ${slotRect.bottom + window.scrollY + slotPaddingBottom}  H ${slotRect.left + slotRect.width / 2} v ${slotPaddingBottom / 2}`;
    this._linepath = this._line.querySelector("path");
    setTimeout(() => {
      this._lineLength = this._linepath.getTotalLength();
      this._linepath.style.strokeDasharray = this._lineLength.toString();
      if (this._animationPlayed) {
        this._linepath.style.strokeDashoffset = this._lineLength - this._headerContent.offsetHeight;
        return;
      }
      this._linepath.style.strokeDashoffset = this._lineLength;
      gsapWithCSS.fromTo(
        this._linepath.style,
        { strokeDashoffset: this._lineLength },
        {
          strokeDashoffset: this._lineLength - this._headerContent.offsetHeight,
          duration: 1,
          onComplete: () => {
            this._animationPlayed = true;
          }
        }
      );
    }, 0);
    ScrollTrigger.create({
      trigger: this,
      start: "top top",
      end: `bottom+=${window.innerHeight * 25 / 100} bottom`,
      endTrigger: this._contactTeaser,
      scrub: 1,
      onUpdate: (self) => {
        const animatedLength = this._lineLength - this._headerContent.offsetHeight;
        if (animatedLength - animatedLength * self.progress <= 0) {
          this._linepath.style.strokeDashoffset = 0;
          return;
        }
        this._linepath.style.strokeDashoffset = animatedLength - animatedLength * self.progress;
      }
    });
  }
  _renderHeroImage() {
    if (this.backgroundVideoSrc) {
      return ke`<jb-video
        class="background"
        .src=${this.backgroundVideoSrc}
        isBackground
      ></jb-video>`;
    }
    return ke`<img
      class="background"
      src="${this.backgroundImage}"
    />`;
  }
  render() {
    return ke`
      <section>
        <header>
          ${this._renderHeroImage()}
          <div class="content">
            ${this.breadcrumbs && ke`
              <jb-breadcrumbs>
                ${this.breadcrumbs.backlink && ke`<jb-breadcrumbs-back-link
                  .link=${this.breadcrumbs.backlink.link}
                  .text=${this.breadcrumbs.backlink.text}
                  slot="backlink"
                ></jb-breadcrumbs-back-link>`}
                ${this.breadcrumbs.items?.map(
      (breadcrumb) => ke`<jb-breadcrumbs-item
                      .link=${breadcrumb.link}
                      .text=${breadcrumb.text}
                      slot="items"
                    ></jb-breadcrumbs-item>`
    )}
              </jb-breadcrumbs>
            `}
            ${this.headline ? ke`<h1>${this.headline}</h1>` : D}
            ${this.subline ? ke`<p>${this.subline}</p>` : D}
          </div>
        </header>
        <button
          @click=${() => {
      smoothScroll(this._main);
    }}
        >
          <jb-chevron-icon></jb-chevron-icon>
        </button>
        <main>
          <div class="content">
            ${this.video ? ke`<jb-video
                  .captions=${this.video.captions}
                  src="${this.video.src}"
                  muted
                  iconPath="${this.video.iconPath}"
                  poster="${this.video.poster}"
                ></jb-video>` : D}
            <slot></slot>
            <jb-contact-teaser-legacy
              .headline=${this.contactTeaser?.headline}
              .subheadline=${this.contactTeaser?.subheadline}
              .text=${this.contactTeaser?.text}
              .color=${this.contactTeaser?.color}
            >
              ${this.contactTeaser.buttons ? this.contactTeaser.buttons.map((button, buttonIndex) => {
      if (button.variant) {
        switch (button.variant) {
          case "secondary":
            return ke`<jb-button-secondary
                            .link=${button.link}
                            inverted
                            >${button.text}</jb-button-secondary
                          >`;
          case "tertiary":
            return ke`<jb-button-tertiary
                            .link=${button.link}
                            inverted
                            >${button.text}</jb-button-tertiary
                          >`;
          case "primary":
          default:
            return ke`<jb-button-primary
                            .link=${button.link}
                            inverted
                            >${button.text}</jb-button-primary
                          >`;
        }
      } else {
        return buttonIndex === 0 ? ke`<jb-button-secondary
                            .link=${button.link}
                            inverted
                            >${button.text}</jb-button-secondary
                          >` : ke`<jb-button-primary
                            .link=${button.link}
                            inverted
                            >${button.text}</jb-button-primary
                          >`;
      }
    }) : D}
            </jb-contact-teaser-legacy>
          </div>
        </main>
        <svg
          class="line"
          xmlns="http://www.w3.org/2000/svg"
        >
          ${Oe`<path d="${this._pathString}"/>`}
        </svg>
      </section>
    `;
  }
};
JBMomentPageHero.styles = r(jb_moment_page_hero_default);
__decorateClass([
  n()
], JBMomentPageHero.prototype, "backgroundImage", 2);
__decorateClass([
  n()
], JBMomentPageHero.prototype, "backgroundMobileImage", 2);
__decorateClass([
  n()
], JBMomentPageHero.prototype, "backgroundVideoSrc", 2);
__decorateClass([
  n({ type: Object })
], JBMomentPageHero.prototype, "breadcrumbs", 2);
__decorateClass([
  n({ type: Object })
], JBMomentPageHero.prototype, "contactTeaser", 2);
__decorateClass([
  n()
], JBMomentPageHero.prototype, "headline", 2);
__decorateClass([
  n()
], JBMomentPageHero.prototype, "subline", 2);
__decorateClass([
  n({ type: Object })
], JBMomentPageHero.prototype, "video", 2);
__decorateClass([
  e("jb-contact-teaser-legacy")
], JBMomentPageHero.prototype, "_contactTeaser", 2);
__decorateClass([
  e("header .content")
], JBMomentPageHero.prototype, "_headerContent", 2);
__decorateClass([
  e("header")
], JBMomentPageHero.prototype, "_headerElement", 2);
__decorateClass([
  e(".line")
], JBMomentPageHero.prototype, "_line", 2);
__decorateClass([
  e("main")
], JBMomentPageHero.prototype, "_main", 2);
__decorateClass([
  r2()
], JBMomentPageHero.prototype, "_pathString", 2);
JBMomentPageHero = __decorateClass([
  customElement("jb-moment-page-hero")
], JBMomentPageHero);

export {
  JBMomentPageHero
};
